module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAUVBMVEUAAADMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMyvntXNAAAAGnRSTlMA9FVOtCB2buVhKLzFnIVIGhQIraWUfe2N23HlKJ8AAADYSURBVCjPfZJZEoQgDEQjIIu478P9DzrApNCkiumvwIO2EwRUq70NwfqzBa55CEU7w7IJLzXizUze89oJrXJ5Pkyk9YBm85FWrkRpqNOU1h0u9nhSkARxQ+HF5AlEyfl3VcdqpnCJxmOuVMwJTFsIfS4sJme9Nbl4gtPmVoSCQ5kg2uqqrU9NMe0YqNpKbQh3GQJsPNKE4yuDl3TwwZAnOxb83h2yymmd318ZIcwWrzHqyG/CaaeeTWUKLXjsr+jdjx2GiJrgpXXFAukHqAi18Ic6qEjay8EXfTkYppmdFB8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/seach-gray-icon.png
// module id = 585
// module chunks = 0